import { Outlet, useLocation, Navigate } from 'react-router-dom'
import { useContext } from 'react'
import { AuthContext } from '@common/context/AuthContext'

const PrivateRoutes = () => {
  const { getAuthToken } = useContext(AuthContext)
  const location = useLocation()

  if (!getAuthToken()) {
    return <Navigate to="/signin" state={{ from: location }} />
  }

  return <Outlet />
}

export default PrivateRoutes
